import styled from "styled-components";
import { Colors } from "../../config/Constants";
import DropdownWithImage from "./DropdownWithImage";

interface Props {
  placeholder: string;
  label?: string;
  onChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => void;
  inputName: string;
  selectName?: string;
  inputValue: string;
  selectValue?: string;
  required: boolean;
  helperText: string;
  disabled?: boolean;
  imageLink: string;
  selectData?: {
    flag: any;
    name: string;
    alpha2Code: string;
    callingCode: string;
  }[];
  type: "image" | "dropdown";
}

interface StyledInputProps {
  helperText: string;
}

const TextfieldWithImage = ({
  onChange,
  placeholder,
  label,
  inputName,
  selectName,
  inputValue,
  selectValue,
  required,
  helperText,
  disabled,
  imageLink,
  selectData,
  type,
}: Props) => {
  // const [displayImg, setDisplayImg] = useState(imageLink);

  return (
    <>
      <InputFieldWrapper>
        {label && (
          <Label>
            {label}
            {required && <span>*</span>}
          </Label>
        )}
        <InputImageWrapper helperText={helperText}>
          <InputImage src={imageLink} width="28px" />
          {type === "dropdown" && selectData && selectName && (
            <DropdownWithImage
              data={selectData}
              value={selectValue}
              onChange={onChange}
              name={selectName}
              required={true}
              helperText={helperText}
              // setImage={setDisplayImg}
            />
          )}
          <Line></Line>
          <InputField
            disabled={disabled}
            onChange={onChange}
            placeholder={placeholder}
            value={inputValue}
            name={inputName}
            autoComplete="off"
          />
        </InputImageWrapper>
        {helperText && <Error>{helperText}</Error>}
      </InputFieldWrapper>
    </>
  );
};

const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const InputField = styled.input`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 0.75rem;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  ::placeholder {
    color: ${Colors.autumnFog};
  }
  :focus {
    outline: none;
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor: no-drop;
  }
  border: 0rem;
  width: 100%;
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 0.8125rem;
  line-height: 1rem;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
  > span {
    color: ${Colors.red};
    margin-left: 0.125rem;
  }
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;
const InputImageWrapper = styled.div<StyledInputProps>`
  display: flex;
  border-radius: 0.25rem;
  border: 1px solid
    ${(props) => (props.helperText ? Colors.red : Colors.athensGrey)};
`;
const InputImage = styled.img`
  margin: 0.4rem 0.4rem;
`;
const Line = styled.div`
  border-left: 1px solid ${Colors.athensGrey};
  height: 1.625rem;
  margin-top: 0.5rem;
  position: relative;
`;

export default TextfieldWithImage;
